export default {
  // ========== Tipos de gráfico ==========
  chartType: 'Tipo de gráfico:',
  bar: 'Barras',
  line: 'Líneas',
  pie: 'Circular',
  doughnut: 'Dona',
}
